import Vue from 'vue';
import moment from 'moment';
import {
  dateFormat,
  datePickerFormat,
  datePickerReplacePattern,
  dateRegex,
} from '@/constants';

interface DateFormatMixin {
  parseDate: (date: string, defaultDate?: string) => string;
  formatDate: (date: string) => string;
}

export default Vue.extend({
  computed: {
    DateFormatMixin(): DateFormatMixin {
      return {
        parseDate: this.parseDate,
        formatDate: this.formatDate,
      };
    },
  },
  methods: {
    parseDate(dateString: string, defaultDate?: string): string {
      if (!dateString) {
        const defaultDateSet = defaultDate
          ? moment(defaultDate, dateFormat)
          : moment();
        return defaultDateSet.format(datePickerFormat);
      }
      if (!(moment(dateString, dateFormat).isValid() && dateRegex.test(dateString))) {
        return null;
      }
      return dateString.replace(dateRegex, datePickerReplacePattern);
    },
    formatDate(date: string): string {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
  },
});
